// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2yAcX","text":"SelectPayment_text__FHz1j","title":"SelectPayment_title__1mxzD","btn":"SelectPayment_btn__2f0Ui"};